module.exports = __webpack_public_path__ + "static/media/welcome.3811f3ee.png";